var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsFi = function SvgNnIconFlagsFi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "#fff",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0067cc",
    d: "M31.5 11.6H18.4V.3c-2.94-.347-6.87-.165-9.08 1.67v9.62H.85c-.788 2.85-1.07 6.52.181 9.08h8.29v9.89c2.63 1.17 6.64 2.28 9.08 1.13v-11h13.1c.879-2.94.879-6.14 0-9.08z"
  })));
};
export default SvgNnIconFlagsFi;